import { IStateReducer } from 'types/reducers'

export const START_REQUEST = 'workaware/app/state/START_REQUEST'
export const END_REQUEST = 'workaware/app/state/END_REQUEST'
export const SET_PAGE_TITLE = 'workaware/app/state/SET_PAGE_TITLE'
export const TOGGLE_SIDEBAR = 'workaware/app/state/TOGGLE_SIDE_BAR'
export const TOGGLE_MOBILE_MENU = 'workaware/app/state/TOGGLE_MOBILE_MENU'

/** @deprecated */
export const OPEN_NEW_ITEM_DRAWER = 'workaware/app/state/OPEN_NEW_ITEM_DRAWER'
/** @deprecated */
export const CLOSE_NEW_ITEM_DRAWER = 'workaware/app/state/CLOSE_NEW_ITEM_DRAWER'
/** @deprecated */
export const SET_FILTER_TEXT = 'workaware/app/state/SET_FILTER_TEXT'

export const startRequest = () => ({ type: START_REQUEST })
export const endRequest = () => ({ type: END_REQUEST })
/**
 * @param title — React node or string shown in the top header
 * @param pathname — Route pathname this title belongs to (defaults to `window.location.pathname`).
 *                   Titles only apply while the current URL matches, so navigating away does not leave a stale header.
 */
export const setPageTitle = (title, pathname?: string | null) => ({
  type: SET_PAGE_TITLE,
  payload: {
    title,
    pathname:
      pathname !== undefined && pathname !== null
        ? pathname
        : typeof window !== 'undefined'
          ? window.location.pathname
          : null,
  },
})
export const toggleSideDrawer = () => ({ type: TOGGLE_SIDEBAR })
export const toggleMobileMenu = () => ({ type: TOGGLE_MOBILE_MENU })

const initialState: IStateReducer = {
  loading: 0,
  pageTitle: '',
  pageTitlePath: null,
  sideMenuExpanded: true,
  mobileMenuOpen: false,
  drawerExpanded: false
}

const stateReducer = (state = initialState, action): IStateReducer => {
  switch (action.type) {
    case SET_PAGE_TITLE: {
      const raw = action.payload
      if (raw && typeof raw === 'object' && raw !== null && 'title' in raw) {
        return { ...state, pageTitle: raw.title, pageTitlePath: raw.pathname ?? null }
      }
      return {
        ...state,
        pageTitle: raw,
        pageTitlePath: typeof window !== 'undefined' ? window.location.pathname : null,
      }
    }
    case START_REQUEST:
      return Object.assign({}, state, { loading: state.loading + 1 })
    case END_REQUEST:
      return Object.assign({}, state, { loading: Math.max(state.loading - 1, 0) })
    case TOGGLE_SIDEBAR:
      return { ...state, sideMenuExpanded: !state.sideMenuExpanded }
    case TOGGLE_MOBILE_MENU:
      return { ...state, mobileMenuOpen: !state.mobileMenuOpen }
    default:
      return state
  }
}

export default stateReducer
